<div class="container">
    <div class="message flex center column">
        <mat-icon style="color: #BEBEBE;">sentiment_dissatisfied</mat-icon>
        <h1>¡Uy no hemos podido encontrar el enlace!</h1>
        <button mat-stroked-button color="primary" (click)="goBack()">Regresar</button>
    </div>

</div>